export enum PaymentCollectionTarget {
  WEBSITE = "website",
  CARD_READER = "card_reader",
}
